import React, { useState } from 'react';
import AlignmentGuidelines, {
  CENTERING_LINES,
  OnSnapDrag,
} from 'components/AlignmentGuidelines';
import useSnapLines from 'components/AlignmentGuidelines/useSnapLines';
import { useEditSceneModalStateContext } from 'containers/EditSceneModal/state';
import { Size } from 'types';

export type UseCaptionsDragAlignmentProps = {
  size: Size<number>;
  onDragStart?: OnSnapDrag;
  onDragStop?: OnSnapDrag;
};

export default function useCaptionsDragAlignment({
  size,
  onDragStart,
  onDragStop,
}: UseCaptionsDragAlignmentProps) {
  const [isDragging, setIsDragging] = useState(false);

  const {
    state: { previewDimensions },
  } = useEditSceneModalStateContext();

  const {
    activeLines,
    dragAxis,
    onDrag,
    onDragStart: snapOnDragStart,
    onDragStop: snapOnDragStop,
  } = useSnapLines({
    anchors: ['center'],
    containerSize: previewDimensions,
    lines: CENTERING_LINES,
    size: size || { width: 0, height: 0 },
    stickiness: 10,
    onDragStart: (e, dragData, snapData) => {
      setIsDragging(true);
      onDragStart?.(e, dragData, snapData);
    },
    onDragStop: (e, dragData, snapData) => {
      setIsDragging(false);
      onDragStop?.(e, dragData, snapData);
    },
  });

  const guidelines = !isDragging ? null : (
    <AlignmentGuidelines
      active={isDragging}
      containerSize={previewDimensions}
      lines={activeLines}
    />
  );

  return {
    dragAxis,
    handleDrag: onDrag,
    handleDragStart: snapOnDragStart,
    handleDragStop: snapOnDragStop,
    guidelines,
  };
}
